import AssignLabelsForm from 'routes/ChapterList/ChapterListActions/AssignLabelsForm/AssignLabelsForm';

export default AssignLabelsForm;
